"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _axios = _interopRequireDefault(require("axios"));

var _Response = _interopRequireDefault(require("./Response"));

var _qs = _interopRequireDefault(require("qs"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

_axios.default.interceptors.request.use(config => {
  config.paramsSerializer = params => {
    // Qs is already included in the Axios package
    return _qs.default.stringify(params, {
      arrayFormat: "brackets",
      encode: true
    });
  };

  return config;
});

class ExternalRequest {
  static async request(data) {
    if (!ExternalRequest.httpClient) {
      ExternalRequest.httpClient = _axios.default;
    }

    let baseUrl = data.baseUrl || ExternalRequest.baseUrl || '';
    let headers = data['headers'] || { ...ExternalRequest.generalHeaders
    };
    let endpoint = data.endpoint || '';
    data = Object.assign({
      crossdomain: true,
      url: `${baseUrl}${endpoint}`,
      headers
    }, data);
    return ExternalRequest.httpClient(data).then(response => {
      return new _Response.default((response === null || response === void 0 ? void 0 : response.data) || null, (response === null || response === void 0 ? void 0 : response.status) || 200, [], null);
    }).catch(err => {
      let result = err === null || err === void 0 ? void 0 : err.response;
      return new _Response.default(null, (result === null || result === void 0 ? void 0 : result.status) || 500, [result === null || result === void 0 ? void 0 : result.data], null);
    });
  }

  static get(data) {
    data['method'] = 'get';
    return this.request(data);
  }

  static put(data) {
    data['method'] = 'put';
    return this.request(data);
  }

  static post(data) {
    data['method'] = 'post';
    return this.request(data);
  }

  static patch(data) {
    data['method'] = 'patch';
    return this.request(data);
  }

  static delete(data) {
    data['method'] = 'delete';
    return this.request(data);
  }

  static setHeader(header, value) {
    this.generalHeaders[header] = value;
  }

  static setHeaders(headersArray = []) {
    Object.keys(headersArray).map(key => {
      this.setHeader(key, headersArray[key]);
    });
  }

}

exports.default = ExternalRequest;

_defineProperty(ExternalRequest, "httpClient", null);

_defineProperty(ExternalRequest, "baseUrl", '');

_defineProperty(ExternalRequest, "generalHeaders", []);